import React, { useEffect, useRef, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import useModal from '../../../hooks/useModal';
import Input from '../../../components/form-controls/Input';
import Button from '../../../components/form-controls/Button';
import InvalidFeedback from '../../../components/InvalidFeedback';
import Select from "../../../components/form-controls/Select";
import { SubAccountService } from '../../../services/SubaccountService';
import { useCurrentAccount } from '../../../hooks/useCurrentAccount';
import { FormService } from '../../../services/FormsService';
import { FollowConfigService } from '../../../services/FollowConfigService';
import { AlertService } from '../../../services/Alert';

interface AddFollowModalProps {
    show: boolean
    onRequestClose: (refresh: boolean) => void;
    payload: any
}

export default function AddFollowModal({ show, onRequestClose, payload }: AddFollowModalProps) {
    const modalRef = useRef<HTMLDivElement>(null)

    useModal(modalRef, show)

    const defaultValues = {
        id: '',
        name: '',
        trigger: null,
        sub_account_id: null,
        form_id: null,
    }
    const { register, handleSubmit, reset, watch, formState: { errors, isValid, isSubmitting } } = useForm({
        mode: 'onChange',
        defaultValues
    });

    const { account } = useCurrentAccount();
    const [subaccounts, setSubAccounts] = useState<any>([]);
    const [forms, setForms] = useState<any>([]);

    const closeAndReset = async (reload: boolean) => {
        await onRequestClose(reload);
        reset(defaultValues);
    }
    const getSubaccounts = async () => {
        const { data } = await SubAccountService.getSubaccounts(account.id)
        setSubAccounts(data.sub_accounts)
    }

    const getForms = async () => {
        const { data } = await FormService.getForms(account.id)
        setForms(data);
    }

    useEffect(() => {
        reset({
            id: payload?.id ? payload.id : defaultValues.id,
            name: payload && payload.name ? payload.name : defaultValues.name,
            trigger: payload?.trigger ? payload.trigger : defaultValues.trigger,
            sub_account_id: payload?.sub_account_id ? payload.sub_account_id : defaultValues.sub_account_id,
            form_id: payload?.form_id ? payload.form_id : defaultValues.form_id
        })
    }, [payload])

    useEffect(() => {
        getSubaccounts()
        getForms();
    }, []);
    const submit = async (data) => {
        try {
            payload != null ? await FollowConfigService.editTag(account.id, data) : await FollowConfigService.addTag(account.id, data);
            await onRequestClose(true);
            reset(defaultValues);
            AlertService.toastSuccess('Se ha guardado correctamente el seguimiento')
        } catch (error) {
            console.log(error)
            AlertService.error('Error', 'No se pudo guardar el seguimiento ¡Intenta de nuevo!')
        }
    }

    return (
        <div className='modal fade' ref={modalRef} data-bs-backdrop="static" data-bs-keyboard="false">
            <div className="modal-dialog " role="document">
                <form onSubmit={handleSubmit(submit)}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title" >{watch('id') ? 'Editar' : 'Agregar'} Seguimiento</h4>
                            <button type="button" className="btn-close" onClick={() => closeAndReset(false)}></button>
                        </div>
                        <div className="modal-body">
                            <div className="mb-3">
                                <Input label={'Nombre *'} errors={errors.name} {...register('name', { required: true })} />
                            </div>
                            <div className="mb-3">
                                <Select
                                    label={'Disparador *'}
                                    data={[
                                        { value: '', text: 'Seleccione una opción', disabled: true },
                                        { value: 'none', text: 'Sin Disparador' },
                                        { value: 'sleep', text: 'Colocar en espera' },
                                        { value: 'redirect', text: 'Redireccionar' },
                                        { value: 'close', text: 'Cierre' },
                                    ]}
                                    errors={errors.trigger}
                                    {...register('trigger', { required: true })}
                                />
                            </div>
                            {
                                watch('trigger') === 'redirect' && (
                                    <div className="mb-3">
                                        <Select
                                            label={'Subcuentas *'}
                                            data={[{ value: '', text: 'Seleccione una opción', disabled: true }].concat(subaccounts.map(a => ({ value: a.id, text: a.name })))}
                                            errors={errors.sub_account_id}
                                            {...register('sub_account_id',{required:true})}
                                        />
                                    </div>
                                )
                            }
                            {
                                watch('trigger') === 'close' && (
                                    <div className="mb-3">
                                        <Select
                                            label={'Formulario *'}
                                            data={[{ value: '', text: 'Seleccione una opción', disabled: true }].concat(forms.map(a => ({ value: a.id, text: a.name })))}
                                            errors={errors.form_id}
                                            {...register('form_id',{required:true})}
                                        />
                                    </div>
                                )
                            }

                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-white btn-sm" onClick={() => closeAndReset(false)}>Cancelar</button>
                            <Button type="submit" className="btn btn-primary btn-sm" onClick={handleSubmit(submit)} disabled={!isValid} isLoading={isSubmitting}>{watch('id') ? 'Editar' : 'Guardar'}</Button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}
